export default "__VITE_ASSET__B9rSBTsX__"